const Checkbox = ({ label, checked, onChange }) => {
  return (
    <div className="form-check">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="form-check-input"
      />
      <label className="form-check-label">{label}</label>
    </div>
  );
};

export default Checkbox;